export const GET_ITEM_LIST = 'GET_ITEM_LIST'
export const DELETE_ITEM_BY_ID = 'DELETE_ITEM_BY_ID'
export const DELETE_ITEMS_IN_BULK = 'DELETE_ITEMS_IN_BULK'
export const GET_ITEM_BY_ID = 'GET_ITEM_BY_ID'
export const ADD_ITEM = 'ADD_ITEM'
export const UPDATE_ITEM = 'UPDATE_ITEM'
